<template>
  <AdministrationHeader>
    <AdministrationPanel :load="load" v-slot="{ data, refresh }">
      <ContainersOverview :data="data" :callback="refresh" />
    </AdministrationPanel>
  </AdministrationHeader>
</template>

<script>
import AdministrationHeader from "@/administration/components/AdministrationHeader.vue";
import AdministrationPanel from "@/administration/components/AdministrationPanel.vue";
import ContainersOverview from "@/administration/components/ContainersOverview.vue";
import {AdministrationController} from "@/administration/controllers/AdministrationController";

export default {
  name: 'AdministrationContainersView',
  components: {AdministrationHeader, AdministrationPanel, ContainersOverview},
  methods: {
    load: () => AdministrationController.getContainers(),
  },
}
</script>

<style lang="stylus" scoped>
@require '~/src/common/style/common.styl';

h1
  color THEME_COLOR_PRIMARY
  span
    color THEME_COLOR_PRIMARY_FADDED
</style>
